import {Routes} from '@angular/router';

export const content: Routes = [
  {
    path: 'home',
    loadChildren: () =>
      import('../../layouts/components/home/home.module').then(
        (m) => m.HomeModule
      )
  },
  {
    path: 'exam',
    loadChildren: () =>
      import('../../layouts/components/exam-screen/exam-screen.module').then(
        (m) => m.ExamScreenModule
      )
  },
  {
    path: 'feedback',
    loadChildren: () =>
      import('../../layouts/components/feedback/feedback.module').then(
        (m) => m.FeedbackModule
      )
  }
];

export const landing: Routes = [
  {
    path: 'landing',
    loadChildren: () =>
      import('../../landing/pages-list/Landing/Landing.module').then(
        (m) => m.LandingModule
      )
  }
];
